import { useSearchParams } from "~/hooks/useSearchParams";
import { useSession } from "contexts/AuthContext";
import {
  CODES_KIND_PARAM,
  CodesKind,
  getDefaultCodesKind,
  parseCodesKind,
} from "shared/constants";

/** The scheme in the URL, else the organisation's default. */
export const useCodesKind = (
  onSwitch: (fromKind: CodesKind, toKind: CodesKind) => void,
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { organisation } = useSession();
  const kind =
    parseCodesKind(searchParams.get(CODES_KIND_PARAM)) ??
    getDefaultCodesKind(organisation.settings);

  const switchKind = (toKind: CodesKind) => {
    if (toKind === kind) return;
    onSwitch(kind, toKind);
    setSearchParams(
      (params) => {
        params.set(CODES_KIND_PARAM, toKind);
        // A search query is written for one scheme's codes.
        params.delete("q");
        return params;
      },
      { replace: true },
    );
  };

  return { kind, switchKind };
};
